export enum XIDR_USER_VERIFICATION_ACTIONS {
  SET_POB_LIST = 'XIDR_USER_VERIFICATION_ACTIONS.SET_POB_LIST',
}
